var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4,6h2v2h-2v-2Zm0,12h2v-2h-2v2Zm0-5h2v-2h-2v2Zm4-7v2h12v-2H8Zm0,7h12v-2H8v2Zm0,5h12v-2H8v2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconList);
export default __webpack_public_path__ + "static/1788088179/media/icon-list.7ede5eaf85dea4c8ef8096d990d0ecfc.svg";
export { ForwardRef as ReactComponent };